import { AccountFilter } from '../../../../../shared/types/modules/account';

export const initialValues: AccountFilter = {
    typeDocument: '',
    document: '',
    name: '',
    cellPhone: '',
    email: '',
    created_at: undefined,
    active: true,
};
